import { Abstract } from '@questwork/q-congress-model'

const Config = {
  getInstance() {
    return {
      frontend: {
        abstract: {
          presentationType: {},

        }
      }
    }
  }
}

class AbstractCongress extends Abstract {
  constructor(options = {}) {
    options = {
      ...options,
      _constructor: {
      }
    }
    super(options)

    // add __properties from mongo aggregation
    this.__completedReviewCount = options.__completedReviewCount || 0
    this.__totalReviewCount = options.__totalReviewCount || 0
    this.__totalScores = options.__totalScores || []
  }

  static get _classname() {
    return 'AbstractCongress'
  }

  get __averageScore() {
    if (!this.__completedReviewCount || this.__completedReviewCount === 0) {
      return 0;
    }
    const average = this.__totalScore / this.__completedReviewCount;
    return parseFloat(average.toFixed(2))
  }

  get __totalScore() {
    return this.__totalScores.reduce((acc, score) => acc + score, 0)
  }

  isValidAbstract() {
    return this.isValid && this.authors.length > 0
  }
  get abstractId () {
    return this.id || this._id
  }

  get displayFinalPresentationType() {
    if (!this.finalPresentationType) {
      return ''
    }
    const presentationType = Config.getInstance().frontend?.abstract?.presentationType || {}
    return presentationType[this.finalPresentationType] || this.finalPresentationType.replace('_', ' ')
  }
  get displayPresentationType() {
    if (!this.presentationType) {
      return ''
    }
    const presentationType = Config.getInstance().frontend?.abstract?.presentationType || {}
    return presentationType[this.presentationType] || this.presentationType.replace('_', ' ')
  }
  displayResponse() {
    if (this.isDeclined) {
      return 'Declined'
    }
    if (this.isAccepted) {
      return this.displayFinalPresentationType()
    }
    return 'Pending'
  }
  get displaySelectedPresentationType() {
    if (!this.selectedPresentationType) {
      return ''
    }
    const presentationType = Config.getInstance().frontend?.abstract?.presentationType || {}
    return presentationType[this.selectedPresentationType] || this.selectedPresentationType.replace('_', ' ')
  }
  get displaySubmittedPresentationType() {
    if (!this.submittedPresentationType) {
      return ''
    }
    const presentationType = Config.getInstance().frontend?.abstract?.presentationType || {}
    return presentationType[this.submittedPresentationType] || this.submittedPresentationType.replace('_', ' ')
  }
  getAuthors() {
    return this.authors
  }
  getDetail(key) {
    if (this.detail[key]) {
      return [this.detail[key]]
    }
    return []
  }
  getConclusions() {
    return this.getDetail('conclusions')
  }
  getKeywords() {
    if (this.detail.keywords) {
      return this.detail.keywords
    }
    return []
  }
  getMethods() {
    return this.getDetail('methods')
  }
  getPurpose() {
    return this.getDetail('purposes')
  }
  getResults() {
    return this.getDetail('results')
  }
  getTitle() {
    return this.getDetail('title')
  }
  resetAuthorDecision() {
    this.finalPresentationType = null
    this.presenterCode = null
    this.resetDecision()
    return this
  }

}

export default {
  AbstractCongress
}
export {
  AbstractCongress
}
